export default "__VITE_ASSET__CC_k09Kp__"